import { useState } from "react";
import { CalendarPlus, Download } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useApi, Panel, Field, btn, inputCls } from "./kit";

function Links({ rid }) {
  const { data } = useApi(`/reviews/${rid}/meeting-links`);
  if (!data) return null;
  return (
    <div className="space-y-2" data-testid="meeting-info">
      <p className="font-semibold" data-testid="meeting-when">{data.when}</p>
      <div className="flex flex-wrap gap-2">
        <a className={btn.ghost} href={data.google} target="_blank" rel="noreferrer" data-testid="meeting-google"><CalendarPlus className="h-4 w-4" /> Add to Google Calendar</a>
        <a className={btn.ghost} href={`${process.env.REACT_APP_BACKEND_URL}${data.ics}`} data-testid="meeting-ics"><Download className="h-4 w-4" /> Outlook / Apple (.ics)</a>
      </div>
    </div>
  );
}

export function MeetingPanel({ r, rev, reload }) {
  const m = r.meeting;
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ date: m?.date || r.meeting_date || "", time: m?.time || "10:00", duration: m?.duration || 60, location: m?.location || "", note: m?.note || "" });
  const set = (k) => (e) => setF({ ...f, [k]: k === "duration" ? Number(e.target.value) : e.target.value });
  const send = async (e) => {
    e.preventDefault();
    try { await api.post(`/reviews/${r.id}/meeting`, f); toast.success(m ? "Updated invite sent to both of you." : "Invite sent to both of you."); setOpen(false); reload(); } catch (err) { toast.error(errMsg(err)); }
  };
  if (!m && (!rev || r.status === "completed")) return null;
  return (
    <Panel title="Review meeting" testid="meeting-panel">
      {m ? <Links key={`${m.seq}`} rid={r.id} /> : <p className="text-sm text-muted-foreground">Pick a time to talk it through. You'll both get an email with a calendar invite.</p>}
      {rev && r.status !== "completed" && !open && <button className={`${m ? btn.ghost : btn.dark} mt-3`} onClick={() => setOpen(true)} data-testid="meeting-open">
        <CalendarPlus className="h-4 w-4" /> {m ? "Change time" : "Schedule meeting"}</button>}
      {open && (
        <form onSubmit={send} className="mt-4 grid gap-3 sm:grid-cols-3" data-testid="meeting-form">
          <Field label="Date" htmlFor="mt-d"><input id="mt-d" type="date" required className={inputCls} value={f.date} onChange={set("date")} data-testid="meeting-date" /></Field>
          <Field label="Start time" htmlFor="mt-t"><input id="mt-t" type="time" required className={inputCls} value={f.time} onChange={set("time")} data-testid="meeting-time" /></Field>
          <Field label="Length" htmlFor="mt-l"><select id="mt-l" className={inputCls} value={f.duration} onChange={set("duration")} data-testid="meeting-duration">
            {[30, 45, 60, 90, 120].map((n) => <option key={n} value={n}>{n < 60 ? `${n} min` : `${n / 60} hr${n > 60 ? "s" : ""}`}</option>)}</select></Field>
          <div className="sm:col-span-3"><Field label="Where" htmlFor="mt-w"><input id="mt-w" className={inputCls} placeholder="e.g. Taproom office, or a video link" value={f.location} onChange={set("location")} data-testid="meeting-location" /></Field></div>
          <div className="sm:col-span-3"><Field label="Note (optional)" htmlFor="mt-n"><textarea id="mt-n" rows={2} className={inputCls} value={f.note} onChange={set("note")} data-testid="meeting-note" /></Field></div>
          <div className="flex gap-2 sm:col-span-3"><button className={btn.primary} data-testid="meeting-send">{m ? "Send updated invite" : "Send invite"}</button>
            <button type="button" className={btn.ghost} onClick={() => setOpen(false)}>Cancel</button></div>
        </form>)}
    </Panel>
  );
}
